import React from "react";
import FieldWrapper from "./FieldWrapper";
import ExamStatus from "./Fields/ExamStatus";
import Passport from "./Fields/Passport";
import ExamScore from "./Fields/ExamScore/ExamScore";
import {FieldData, UserLevels} from "../../../containers/RegistrationLoginPage/types";
import {FormUl} from "./loaderStyled";
import BudgetWrapper from "./Fields/BudgetWrapper";

interface ExamSectionInterface {
    fields: FieldData;
    level: UserLevels | undefined | null;
}

const ExamSection: React.FC<ExamSectionInterface> = ({fields, level}: ExamSectionInterface) => {
    return (
        <>
            <FormUl>
                {fields?.examStatus && (
                    <FieldWrapper visible={fields.examStatus.visible}>
                        <ExamStatus configuration={fields.examStatus} level={level} />
                    </FieldWrapper>
                )}
                <Passport />
                <ExamScore />
                <BudgetWrapper />
            </FormUl>
        </>
    );
};

export default ExamSection;
